<ng-container *transloco="let t">
  <pxw-product-option-selector-wrapper
    [name]="option() | propInSelectedLanguage: 'name' : selectedLanguage() : true"
    [instructions]="optionInstructions()"
    [isOptional]="!optionRequired()"
    [isRequired]="optionRequired()"
  >
    @if (isSingleChoice()) {
      <pxw-input-radio-group
        [name]="'option-' + option().id"
        [options]="optionItems()"
        [ngModel]="selectedItemIds()[0]"
        [disabledValues]="disabledItemIds()"
        (ngModelChange)="onSingleChoiceSelected($event)"
        valueKey="id"
      >
        <ng-template #itemTemplate let-item>
          @let maxCount = getMaxCountForItem(item, option(), optionMin());

          <pxw-product-option-item-radio
            [optionId]="option().id"
            [optionMin]="optionMin()"
            [item]="item"
            [cartItemId]="cartItemId()"
            [displaySku]="displaySku()"
            [selectedLanguage]="selectedLanguage()"
            [count]="selectedItemQuantities()[item.id] || 0"
            [disableIncrement]="disableIncrement()"
            [displayItemQuantities]="option().displayItemQuantities || false"
            [maxCount]="maxCount"
            [stockDisplayCondition]="stockDisplayCondition()"
            [stockDisplayConditionValue]="stockDisplayConditionValue()"
            [displayProductPriceWithoutTaxes]="displayProductPriceWithoutTaxes()"
            (itemImageClick)="onItemImageClick(item)"
          />
        </ng-template>
      </pxw-input-radio-group>
    } @else {
      <pxw-input-checkbox-group
        [name]="'option-' + option().id"
        [options]="optionItems()"
        [ngModel]="selectedItemIds()"
        valueKey="id"
        [disabledValues]="disabledItemIds()"
        [legendToggleEnabled]="false"
        (checkboxToggle)="onToggleOption($event.option, $event.nextState)"
      >
        <ng-template #itemTemplate let-item let-onToggle="onToggle">
          @let maxCount = getMaxCountForItem(item, option(), optionMin());

          <pxw-product-option-item-checkbox
            [optionId]="option().id"
            [optionMin]="optionMin()"
            [item]="item"
            [cartItemId]="cartItemId()"
            [displaySku]="displaySku()"
            [selectedLanguage]="selectedLanguage()"
            [count]="selectedItemQuantities()[item.id] || 0"
            [disableIncrement]="disableIncrement()"
            [displayItemQuantities]="option().displayItemQuantities || false"
            [maxCount]="maxCount"
            [stockDisplayCondition]="stockDisplayCondition()"
            [stockDisplayConditionValue]="stockDisplayConditionValue()"
            [displayProductPriceWithoutTaxes]="displayProductPriceWithoutTaxes()"
            (countChange)="onOptionItemCountChange(item, $event)"
            (itemImageClick)="onItemImageClick(item)"
            (itemNameClick)="onToggle($event)"
          />
        </ng-template>

        @let validationError = validationErrorRule();

        @if (validationError) {
          <pxw-form-validation
            [name]="'selectedItemsCount-' + option().id"
            [ngModel]="selectedItemsCount()"
            [displayErrors]="displayErrors() || disableIncrement()"
            [min]="validationError.min"
            [max]="validationError.max"
            [messages]="{
              min: validationError.message,
              max: validationError.message,
            }"
          />
        }
      </pxw-input-checkbox-group>
    }
  </pxw-product-option-selector-wrapper>
</ng-container>
